import * as read_api from "./alan_api";
export function serialize($_report_protocol_request: read_api.Creport_protocol_request) {
	const raw_data: Record<string, any> = {};
	{
		let raw_access_type: Record<string, any>;
		switch ($_report_protocol_request.properties.access_type.state.name) {
			case 'anonymous': {
				const $_anonymous = $_report_protocol_request.properties.access_type.state.node;
				const raw_data: Record<string, any> = {};
				raw_access_type = raw_data
				break;
			}
			case 'authenticated': {
				const $_authenticated = $_report_protocol_request.properties.access_type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["token"] = $_authenticated.properties.token;
				raw_access_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_report_protocol_request.properties.access_type.state)
		}
		raw_data["access type"] = [$_report_protocol_request.properties.access_type.state.name, raw_access_type];
	}
	{
		let raw_type: Record<string, any>;
		switch ($_report_protocol_request.properties.type.state.name) {
			case 'delete': {
				const $_delete = $_report_protocol_request.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["report"] = $_delete.properties.report;
				raw_type = raw_data
				break;
			}
			case 'listing': {
				const $_listing = $_report_protocol_request.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			case 'upload': {
				const $_upload = $_report_protocol_request.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["name"] = $_upload.properties.name;
				raw_data["template"] = $_upload.properties.template;
				raw_data["type"] = $_upload.properties.type;
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_report_protocol_request.properties.type.state)
		}
		raw_data["type"] = [$_report_protocol_request.properties.type.state.name, raw_type];
	}
	return raw_data;
}